<template>
  <div>
    <b-modal title="Attachment Item" :visible="isOpen" @hide="$emit('close', false)" ok-only ok-title="Close">
      <div class="p-2 -100 d-flex justify-content-between border-b" v-for="(item, index) in attachments" :key="index">
        <p class="m-0">Attachment {{ index + 1 }}</p>
        <b-button v-if="item?.id" size="sm" @click="handleDownloadFile(item)">
          <i class="fa fa-download"></i> Download</b-button>
        <a  v-else :href="(item?.id ? apiUrl : '') + (item?.url ?? item?.path)" target="_blank">
          <b-button size="sm">
            <i class="fa fa-download"></i> Download</b-button>
          </a>
        <img v-if="item?.type?.includes('image')" :src="apiUrl + (item?.url ?? item?.path)" class="img-fluid"
          style="max-width: 100px; max-height: 100px;" alt="attachment" />
      </div>
    </b-modal>
  </div>
</template>
<script>
import { previewFile } from '@/src/plugins/helpers';

export default {
  name: 'ModalAttachment',
  props: {
    isOpen: Boolean,
    attachments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      apiUrl: `${process.env.VUE_APP_API_BASE_URL}/sr/`,
    };
  },
  methods: {
    handleDownloadFile(item) {
      // saveAs(`${this.apiUrl}${item?.url || item?.path}`, item?.name)
      const url = `${this.apiUrl}${item?.url || item?.path}`
      previewFile(url)
    }
  },
}
</script>
<style></style>
